export enum AIAgentSecurityRight {
    // Master toggle
    CanUseAgent = 70000,

    // Module access (controls entity reading + tool gating per domain)
    AccessJobs = 70010,
    AccessCRM = 70011,
    AccessFinance = 70012,
    AccessCatalogue = 70013,
    AccessDocs = 70014,
    AccessEquipment = 70015,
    AccessQuotes = 70016,
    // Read-only: appointments (Scheduler board, stage Appointments tabs) and run sheets.
    AccessScheduler = 70017,

    // Module-level full-write rights (the only write rights configured per role).
    // Each expands to every granular write scope for its module at resolution time
    // (see ai.permission.mapper.ts). 70053-70056 are reserved for future
    // write-capable modules (Catalogue/Docs/Equipment/Quotes).
    WriteJobs = 70050,
    WriteCRM = 70051,
    WriteFinance = 70052,

    // Granular write scope catalog (DEPRECATED for per-role config).
    // No longer toggled individually in the roles UI. Retained as the registry of
    // write scopes that module-level full-write rights expand into, and as the
    // vocabulary for future tenant-wide tool policy / skill bundling.
    WriteJobDescription = 70020,
    WriteJobNotes = 70021,
    WriteJobLineItems = 70022,
    WriteJobStageDates = 70023,
    WriteJobStageOrder = 70024,
    WriteCrmAccounts = 70025,
    WriteBillScan = 70026,
    WriteJobDetails = 70027,
    WriteJobAssignments = 70028,
    WriteJobSite = 70029,
    WriteJobStatus = 70030,
    WriteWorkOrderStatus = 70031,
    WriteStageRename = 70032,
    WriteStageAssignment = 70033,
    WriteTasks = 70034,
    WriteStageCategory = 70035,
    WriteInvoiceCreate = 70039,
    WriteInvoiceEdit = 70040,
    WriteInvoiceLineItems = 70041,
    WriteInvoiceSend = 70042,
    WriteInvoiceSync = 70043,

    // Skill permissions
    SkillWbfFormBuilder = 70100,
    SkillStageScheduling = 70101,
}
